module.exports = __webpack_public_path__ + "img/mask.014ddca3.png";